<script setup lang="ts">
import LohnletterListComponent from '@/components/LohnletterListComponent.vue'
import { inject } from 'vue'

const t = inject('t')
const setTitle = inject('setTitle')
setTitle(t('tipps-und-tricks'))
</script>

<template>
  <h1>{{ t('tipps-und-tricks') }}</h1>
  <LohnletterListComponent></LohnletterListComponent>
</template>
